import React, { useEffect } from 'react';
import './About.css';

export default function About() {
  useEffect(() => {
    document.title = 'About Us';
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/about_banner.webp)' }}>
        <h1 className="page-banner-title" id="about-us-heading">
          About Us
        </h1>
      </div>
      <section className="page-content-wrapper" aria-labelledby="about-us-heading">
        <p className="about-text-content">
          Inalab is a trusted partner for U.S. Federal Government agencies, delivering AI-driven technology and mission support solutions that power programs of national importance. Our unwavering commitment to quality, security, and innovation enables mission success for our partners and delivers measurable outcomes for the communities they serve.
        </p>
        <p className="about-text-content">
          We believe that today's challenges demand more than legacy systems. In an era of rapid technological change and complex data environments, federal leaders need a partner who operates at the intersection of strategy and execution. Our approach combines deep domain expertise with a forward-leaning adoption of technology to help our clients break down data silos, accelerate decision-making, and enhance operational readiness.
        </p>
        <p className="about-text-content">
          From enhancing workforce readiness with intelligent staffing to delivering critical capabilities at the speed of need, our innovative solutions are designed for impact across every stage. We empower federal leaders to achieve total situational awareness and ensure mission effectiveness, transforming their data into a decisive advantage for smarter decisions. 
          At Inalab, we don't just support missions—<strong>we accelerate them</strong>.
        </p>
      </section>
    </>
  );
} 